import axios from "axios";
import { fileUploadStart } from "../../../services/file-upload-start";
import { fileUploadComplete } from "../../../services/file-upload-complete";
import { dataUploadProcess } from "../../../services/data-upload-process";

export const uploadAndProcessFile = async (
  files: any,
  formValues: any,
  isFileObject: boolean,
  isDataFormat?: boolean,
  isOfflineFlow?: boolean,
) => {
  const chunkSize = 100 * 1024 * 1024;
  const msdValue = formValues?.MSDCompound || formValues?.msd;
  const compoundNumber = msdValue?.split("-")[0];
  const protocolNumber = msdValue?.split("-")[1];
  const transferIdValue = formValues?.transferId || formValues?.transfer_id;
  const transferId = transferIdValue?.split("-")[0];
  try {
    if (!isFileObject || files.length === 0) {
      return true;
    }

    const fileToUpload = files[0]?.originFileObj;
    if (!fileToUpload) {
      return false;
    }

    // Step 1: Start the upload and get pre-signed URLs
    const fileData = {
      fileName: fileToUpload.name,
      fileSize: fileToUpload.size,
      compoundNumber,
      protocolNumber,
      transferId,
      isDataFormat,
      isOfflineFlow,
      supplierOrg: formValues?.supplierOrganization || formValues?.supplier_org,
      dtsVersion: formValues?.DTSVersion || formValues?.dts_version,
    };

    const resUpdatedUrls = await fileUploadStart(fileData);
    if (!resUpdatedUrls) {
      return false;
    }

    const { uploadUrls, uploadId, key: finalKey } = resUpdatedUrls;
    if (!finalKey || !uploadId || !uploadUrls.length) {
      return false;
    }

    // Step 2: Upload the file in chunks
    const totalChunks = Math.ceil(fileToUpload.size / chunkSize);
    const parts = [];

    for (let i = 0; i < totalChunks; i++) {
      const start = i * chunkSize;
      const end = Math.min(start + chunkSize, fileToUpload.size);
      const chunk = fileToUpload.slice(start, end);
      const url = uploadUrls[i];

      try {
        const response = await axios.put(url, chunk, {
          headers: {
            "Content-Type": "application/octet-stream",
            "Access-Control-Allow-Origin": "*",
          },
        });
        const ETag = response.headers.etag;
        parts.push({ PartNumber: i + 1, ETag });
      } catch (error) {
        return false;
      }
    }

    // Step 3: Complete the upload
    const completeResponse = await fileUploadComplete({
      objectName: finalKey,
      uploadId,
      parts,
      compoundNumber,
      protocolNumber,
      transferId,
      isDataFormat,
      isOfflineFlow,
    });

    if (!completeResponse) {
      return false;
    }

    // Step 4: Process the uploaded file
    const processResponse = await dataUploadProcess({
      fileNames: [finalKey],
      fileCount: 1,
      compound: compoundNumber,
      transferId: "001",
      protocol: protocolNumber,
      isDataFormat,
      isOfflineFlow,
    });

    if (!processResponse) {
      return false;
    }
    return true;
  } catch (error) {
    return false;
  }
};
